import { c as _c } from "react/compiler-runtime";
import { Icon, Title } from "@justhome/react-ui";
import { Maybe } from "@lib/generated/graphql";
import clsx from "clsx";
import { FC, MouseEventHandler, PropsWithChildren, memo } from "react";
const AccordionProgressBar: FC<{
  isTimerActive: boolean;
  isActive: boolean;
  autoOpenInterval?: Maybe<number>;
  serifClass?: string;
}> = t0 => {
  const $ = _c(8);
  const {
    isActive,
    isTimerActive,
    autoOpenInterval,
    serifClass
  } = t0;
  const isShowProgressBar = isTimerActive && isActive;
  if (!isShowProgressBar) {
    return null;
  }
  const t1 = `${autoOpenInterval}ms`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      animationPlayState: "running",
      animationTimingFunction: "linear",
      animationDuration: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const style = t2;
  let t3;
  if ($[2] !== isShowProgressBar || $[3] !== serifClass) {
    t3 = clsx("transition-all h-[6px] bg-current", {
      "animate-progress": isShowProgressBar
    }, serifClass || "text-primary-800");
    $[2] = isShowProgressBar;
    $[3] = serifClass;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== style || $[6] !== t3) {
    t4 = <div className="bg-primary-50 h-[6px] w-full"><div className={t3} style={style} /></div>;
    $[5] = style;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const AccordionItemTitle: FC<PropsWithChildren<{
  title: Maybe<string>;
  isActive: boolean;
  isTimerActive: boolean;
  autoOpenInterval?: Maybe<number>;
  isClosed?: boolean;
  serifClass?: string;
  inverted?: boolean;
  onClick: MouseEventHandler;
}>> = memo(function AccordionItemTitle(t0) {
  const $ = _c(24);
  const {
    isActive,
    title,
    isTimerActive,
    autoOpenInterval,
    serifClass,
    isClosed,
    inverted,
    onClick
  } = t0;
  let t1;
  if ($[0] !== autoOpenInterval || $[1] !== isActive || $[2] !== isTimerActive || $[3] !== serifClass) {
    t1 = <div className="absolute top-none left-none right-none"><AccordionProgressBar isActive={isActive} isTimerActive={isTimerActive} autoOpenInterval={autoOpenInterval} serifClass={serifClass} /></div>;
    $[0] = autoOpenInterval;
    $[1] = isActive;
    $[2] = isTimerActive;
    $[3] = serifClass;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !inverted;
  let t3;
  if ($[5] !== inverted || $[6] !== t2) {
    t3 = clsx("flex justify-between items-center px-3s cursor-pointer transition-all w-full py-3s focusable", {
      "hover:text-primary-825 active:text-primary-875": t2,
      "hover:text-neutral-50 active:text-neutral-100": inverted
    });
    $[5] = inverted;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== inverted || $[9] !== serifClass || $[10] !== title) {
    t4 = <Title serifClass={serifClass} as="h3" inverted={inverted} className="text-h3 text-left pr-2xs">{title}</Title>;
    $[8] = inverted;
    $[9] = serifClass;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = isActive && !isClosed;
  let t6;
  if ($[12] !== t5) {
    t6 = clsx({
      "rotate-180": t5
    });
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Icon size="24" type="Down" className={t6} />;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onClick || $[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
    t8 = <button className={t3} onClick={onClick}>{t4}{t7}</button>;
    $[16] = onClick;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t1 || $[22] !== t8) {
    t9 = <div>{t1}{t8}</div>;
    $[21] = t1;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
});
export default AccordionItemTitle;